/* site/content/shared.js — content every page uses: the four product worlds
 * (mega menu / mobile accordion / listings), company settings, the footer.
 * Verified facts per lhc-site/ARCHITECTURE.md §2; everything else placeholder. */
export const WORLDS = [
  { id: "kitchens", cls: "kitchens", name: "Kitchens", sub: "Horizon · Open · Aria · Mont · Frame · Frame Slim · Concept One", image: "https://picsum.photos/seed/lhc-world-kitchens/1000/1250" },
  { id: "systems", cls: "systems", name: "Systems", sub: "Wardrobes · Walk-In Closets · Beds · Night Complements · Day Systems · Side Boards", image: "https://picsum.photos/seed/lhc-world-systems/700/930" },
  { id: "indoor", cls: "indoor", name: "Indoor", sub: "Sofas · Armchairs · Chaise Lounge · Coffee Tables · Side Tables · Dining Tables · Dining Chairs", image: "https://picsum.photos/seed/lhc-world-indoor/700/930" },
  { id: "outdoor", cls: "outdoor", name: "Outdoor", sub: "Sofas · Armchairs · Chaise Lounge · Coffee Tables · Side Tables · Dining Tables · Dining Chairs", image: "https://picsum.photos/seed/lhc-world-outdoor/1600/610" },
];

export const SETTINGS = {
  brand: "Lugano Home Collection",
  brandShort: "LHC",
  logo: "https://lhc.master.al/web/image/website/1/logo/Lugano%20Home%20Collection?unique=2f2eab0",
  address: ["Rruga Monarkia Shqiptare", "Kamez, Tirana, 1030", "Albania"],
  email: "",
  phone: "",
  social: [
    { label: "Instagram", href: "https://www.instagram.com/lugano_home_collection/" },
    { label: "Pinterest", href: "https://www.pinterest.com/LuganoHome/" },
    { label: "YouTube", href: "https://www.youtube.com/@LuganoHomeCollection" },
    { label: "LinkedIn", href: "https://www.linkedin.com/company/lugano-home-collection/" },
  ],
  copyright: "© 2026 Lugano Home Collection",
  nav: {
    primary: [
      { label: "New", href: "collections.html" },
      { label: "Products", href: "products.html", mega: true },
      { label: "Materials", href: "materials.html" },
      { label: "Projects", href: "projects.html" },
      { label: "Contract", href: "contract.html" },
      { label: "About", href: "about.html" },
    ],
    professional: { label: "Professional Area", href: "resources.html" },
    contact: { label: "Contact", href: "contact.html" },
    megaFeature: { eyebrow: "Featured", image: "https://picsum.photos/seed/lhc-mega-feature/500/380", href: "kitchens.html", label: "View Kitchens", alt: "Placeholder: LHC product photography" },
  },
  search: { placeholder: "Search products, materials, projects…", pending: "search index not yet connected — results for “{q}” pending." },
  footer: {
    eyebrow: "Lugano Home Collection",
    statement: "Furniture for considered interiors.",
    primary: { label: "Start a Project", href: "contract.html" },
    secondary: { label: "Professional Resources", href: "resources.html" },
    columns: [
      { title: "Explore", links: [{ label: "Collections", href: "collections.html" }, { label: "Products", href: "products.html" }, { label: "Kitchens", href: "kitchens.html" }, { label: "Materials", href: "materials.html" }, { label: "Projects", href: "projects.html" }] },
      { title: "Company", links: [{ label: "About", href: "about.html" }, { label: "Contract", href: "contract.html" }, { label: "Professional Resources", href: "resources.html" }, { label: "Become a Partner", href: "login.html#apply" }, { label: "Partner Login", href: "login.html" }, { label: "LHC Studio (dealers)", href: "https://lhcstudio.duckdns.org/", blank: true }] },
    ],
    contactTitle: "Contact",
    contactLink: { label: "Contact LHC", href: "contact.html" },
    followTitle: "Follow",
    legal: [{ label: "Privacy", href: "legal.html#privacy" }, { label: "Terms", href: "legal.html#terms" }, { label: "Cookies", href: "legal.html#cookies" }],
  },
};
